/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

import ENConfig from '../../../config';
const {
  SERVICE_IDENTIFYING_HEADER,
  ION_VERSION_HEADER_NAME,
  FEATURE_VERSION_HEADER
} = ENConfig;

declare const AppVersion: string;

interface Opts {
  headers?: { [key: string]: string };
}

/**
 * Get the options passed into our XHR transport.
 * Note that because we use CORS in development, and you must specify acceptable
 * headers when using CORS, we do not add any headers unless we are bundling for
 * production, stage, or PR branches.
 */
export default function getTransportOpts(): Opts {
  const opts: Opts = {};
  if (process.env.NODE_ENV === 'production-1') {
    opts.headers = {
      [SERVICE_IDENTIFYING_HEADER.NAME]: SERVICE_IDENTIFYING_HEADER.VALUE,
      [FEATURE_VERSION_HEADER.NAME]: FEATURE_VERSION_HEADER.VALUE,
      [ION_VERSION_HEADER_NAME]: AppVersion
    };
  }
  return opts;
}
